import { dynamic } from '#/utils/dynamic';

export const DynamicSearchEventsRefinements = dynamic(
  () =>
    import('./SearchEventsRefinements').then((m) => ({
      default: m.SearchEventsRefinements,
    })),
  { strategy: 'client-only' },
);
